import { UrlMatchResult } from '@angular/router'

export class RegexpMatcher {
  protected static buildExpression (part: string, options: any) {
    return new RegExp('^' + part.replace(/(?:\:([\da-z_]+))(?:\(([^\)]+)\))?/gi,
      (whole, paramId, expression) => {
        if (options.fillParams && options.params && options.data) {
          options.params.push(paramId)
          options.data[paramId] = null
        }
        return expression ? `(${expression})` : ''
      }) + '$', 'i'
    )
  }

  protected static validate (path, expression, options) {
    if (path) {
      const valid = expression.test(path)
      if (valid && options.getData && options.params && options.data) {
        path.replace(expression, (...args) =>
          [].concat(args).slice(1).forEach(
            (value, i) => options.params[i] && (options.data[options.params[i]] = value)
          )
        )
      }
      return valid
    } else {
      return false
    }
  }

  static matcher (segments, route): UrlMatchResult {
    if (segments.length) {
      const consumed = []
      const path = typeof route.data.regexpPath === 'string' ?
        route.data.regexpPath.split('/') :
        [].concat(route.data.regexpPath)
      route.data = { regexpPath: route.data.regexpPath }

      return segments.reduce((valid, segment, index) => {
        const part = path[index] || null
        if (typeof part === 'string') {
          const params = []
          const options = { fillParams: true, getData: true, params: params, data: route.data }
          valid = valid && this.validate(segment.path, this.buildExpression(part, options), options)
          if (valid) {
            consumed.push(segment)
          }
          return valid
        } else if (part) {
          valid = valid && new RegExp(part).test(segment.path)
          if (valid) {
            consumed.push(segment)
          }
          return valid
        } else {
          return true
        }
      }, true) ?
        ({ consumed: consumed }) : null
    } else {
      return null
    }
  }
}
